export const GET_SSR_DATA_SUCCEEDED = 'GET_SSR_DATA_SUCCEEDED';

export default (state = {}, action) => (action.type === GET_SSR_DATA_SUCCEEDED ? action.payload : state);
